"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTeamsTab = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const SortableTable_1 = require("../util/SortableTable");
const UI_1 = require("../util/UI");
const AdminDeliverablesTab_1 = require("./AdminDeliverablesTab");
const AdminPage_1 = require("./AdminPage");
const AdminResultsTab_1 = require("./AdminResultsTab");
const AdminStudentsTab_1 = require("./AdminStudentsTab");
const AdminView_1 = require("./AdminView");
class AdminTeamsTab extends AdminPage_1.AdminPage {
    constructor(remote) {
        super(remote);
        this.teams = [];
        this.students = [];
        this.staff = [];
        this.course = null;
        this.repos = [];
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminTeamsTab::init(..) - start; opts: " + JSON.stringify(opts));
            document.getElementById("teamsListTable").innerHTML = "";
            this.students = [];
            this.teams = [];
            this.repos = [];
            UI_1.UI.showModal("Retrieving teams.");
            this.course = yield AdminView_1.AdminView.getCourse(this.remote);
            const provisionDelivs = (yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(this.remote)).filter((deliv) => deliv.shouldProvision);
            this.repos = yield AdminResultsTab_1.AdminResultsTab.getRepositories(this.remote);
            this.teams = yield AdminTeamsTab.getTeams(this.remote);
            this.students = yield AdminStudentsTab_1.AdminStudentsTab.getPeopleForView(this.remote);
            this.staff = yield AdminStudentsTab_1.AdminStudentsTab.getStaff(this.remote);
            if (typeof opts.delivId === "undefined") {
                const defaultDelivProvisions = provisionDelivs.some((deliv) => deliv.id === this.course.defaultDeliverableId);
                const projectProvisions = provisionDelivs.some((deliv) => deliv.id === "project");
                if (defaultDelivProvisions) {
                    opts.delivId = this.course.defaultDeliverableId;
                }
                else if (projectProvisions) {
                    opts.delivId = "project";
                }
                else {
                    opts.delivId = "-None-";
                }
            }
            if (typeof opts.labSection === "undefined") {
                opts.labSection = "-All-";
            }
            const dStr = ["-None-"];
            for (const deliv of provisionDelivs) {
                dStr.push(deliv.id);
            }
            UI_1.UI.setDropdownOptions("teamsListSelect", dStr, opts.delivId);
            const delivSelector = document.querySelector("#teamsListSelect");
            const statusSelector = document.querySelector("#teamsListStatusSelect");
            const that = this;
            const updateTeamTable = function () {
                const delivValue = delivSelector.value.valueOf();
                const statusValue = statusSelector.value.valueOf();
                Log_1.default.info("AdminTeamsTab::init(..)::updateTeamTable() - deliv: " + delivValue + "; status: " + statusValue);
                if (statusValue === "formed") {
                    Log_1.default.info("AdminTeamsTab::init(..)::updateTeamTable() - rendering formed");
                    that.renderTeams(that.teams, delivValue, opts.labSection);
                }
                else {
                    Log_1.default.info("AdminTeamsTab::init(..)::updateTeamTable() - rendering unformed");
                    that.renderIndividuals(that.teams, that.students, delivValue, opts.labSection);
                }
            };
            delivSelector.onchange = function (evt) {
                Log_1.default.info("AdminTeamsTab::init(..) - deliv changed");
                evt.stopPropagation();
                updateTeamTable();
            };
            statusSelector.onchange = function (evt) {
                Log_1.default.info("AdminTeamsTab::init(..) - status changed");
                evt.stopPropagation();
                updateTeamTable();
            };
            const labSelector = document.querySelector("#teamsListLabSelect");
            labSelector.onchange = function (evt) {
                Log_1.default.info("AdminTeamsTab::init(..) - lab changed");
                evt.stopPropagation();
                opts.labSection = labSelector.value.valueOf();
                updateTeamTable();
            };
            updateTeamTable();
            UI_1.UI.hideModal();
        });
    }
    renderTeams(teams, delivId, labSection) {
        Log_1.default.trace("AdminTeamsTab::renderTeams(.., " + delivId + ", " + labSection + ") - start");
        const headers = [
            {
                id: "num",
                text: "#",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "id",
                text: "Team Id",
                sortable: true,
                defaultSort: true,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "repo",
                text: "Repository",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "labs",
                text: "Labs",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "p1",
                text: "First Member",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "p2",
                text: "Second Member",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "p3",
                text: "Third Member",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
        ];
        let labSectionsOptions = ["-All-", "-Unspecified-"];
        const st = new SortableTable_1.SortableTable(headers, "#teamsListTable");
        let _listContainsStudents = false;
        let count = 1;
        for (const team of teams) {
            let p1 = "";
            let p2 = "";
            let p3 = "";
            if (team.people.length === 0) {
            }
            else if (team.people.length === 1) {
                p1 = this.getPersonCell(team.people[0]);
            }
            else if (team.people.length === 2) {
                p1 = this.getPersonCell(team.people[0]);
                p2 = this.getPersonCell(team.people[1]);
            }
            else if (team.people.length === 3) {
                p1 = this.getPersonCell(team.people[0]);
                p2 = this.getPersonCell(team.people[1]);
                p3 = this.getPersonCell(team.people[2]);
            }
            let repoName = null;
            let repoURL = null;
            for (const repo of this.repos) {
                if (repo.id === team.id) {
                    repoName = repo.id;
                    repoURL = repo.URL;
                }
            }
            let repoDisplay = "<a class='selectable' href='" + repoURL + "'>" + repoName + "</a>";
            if (repoURL === null) {
                repoDisplay = "";
            }
            let teamDisplay = "<a class='selectable' href='" + team.URL + "'>" + team.id + "</a>";
            if (team.URL === null) {
                teamDisplay = team.id;
            }
            const labs = this.getLabsCell(team.people);
            const row = [
                { value: count, html: count + "" },
                { value: team.id, html: teamDisplay },
                { value: repoName, html: repoDisplay },
                { value: labs, html: labs },
                { value: p1, html: p1 },
                { value: p2, html: p2 },
                { value: p3, html: p3 },
            ];
            if (labSectionsOptions.indexOf(labs) < 0 && labs !== "" && labs !== null) {
                labSectionsOptions.push(labs);
            }
            if (delivId === team.delivId && team.people.length > 0) {
                count++;
                if (labSection === labs || labSection === "-All-" || (labSection === "-Unspecified-" && (labs === "" || labs === null))) {
                    st.addRow(row);
                }
                _listContainsStudents = true;
            }
        }
        st.generate();
        labSectionsOptions = labSectionsOptions.sort();
        UI_1.UI.setDropdownOptions("teamsListLabSelect", labSectionsOptions, labSection);
    }
    getLabsCell(people) {
        const labs = people.map((personId) => { var _a; return (_a = this.getPerson(personId)) === null || _a === void 0 ? void 0 : _a.labId; }).filter((lab) => !!lab);
        return [...new Set(labs)].sort().join(",");
    }
    getPerson(personId) {
        var _a;
        return (_a = this.students.find((student) => student.id === personId)) !== null && _a !== void 0 ? _a : null;
    }
    getStaff(personId) {
        var _a;
        return (_a = this.staff.find((staff) => staff.id === personId)) !== null && _a !== void 0 ? _a : null;
    }
    getPersonCell(personId) {
        let render = personId;
        const student = this.getPerson(personId);
        if (student === null) {
            const staff = this.getStaff(personId);
            if (staff === null && personId.startsWith("atest-") === false) {
                render = "Withdrawn: " + personId;
            }
            else {
                render = "Staff: " + personId;
            }
            return render;
        }
        if ((student === null || student === void 0 ? void 0 : student.id) === personId) {
            if (student.userUrl !== null && student.userUrl.startsWith("http") === true) {
                render =
                    "<a class='selectable' href='" +
                        student.userUrl +
                        "'>" +
                        student.githubId +
                        "</a> [" +
                        student.id +
                        "] (" +
                        student.firstName +
                        " " +
                        student.lastName +
                        ")";
            }
            else {
                render = student.githubId + " (" + student.firstName + " " + student.lastName + ")";
            }
        }
        return render;
    }
    renderIndividuals(teams, students, delivId, labSection) {
        var _a;
        Log_1.default.trace("AdminTeamsTab::renderIndividuals(.., " + delivId + ", " + labSection + ") - start");
        const headers = [
            {
                id: "num",
                text: "#",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "lab",
                text: "Lab",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "id",
                text: "Student",
                sortable: true,
                defaultSort: true,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
        ];
        let labSectionsOptions = ["-All-", "-Unspecified-"];
        const st = new SortableTable_1.SortableTable(headers, "#teamsListTable");
        const studentsOnTeams = [];
        for (const team of teams) {
            if (team.delivId === delivId) {
                for (const p of team.people) {
                    studentsOnTeams.push(p);
                }
            }
        }
        let _listContainsStudents = false;
        let count = 1;
        for (const student of students) {
            if (studentsOnTeams.indexOf(student.id) < 0) {
                const lab = (_a = student.labId) !== null && _a !== void 0 ? _a : "";
                if (labSectionsOptions.indexOf(lab) < 0 && lab !== "" && lab !== null) {
                    labSectionsOptions.push(lab);
                }
                const studentHTML = student.firstName +
                    " " +
                    student.lastName +
                    " <a class='selectable' href='" +
                    student.userUrl +
                    "'>" +
                    student.githubId +
                    "</a> (" +
                    student.firstName +
                    " " +
                    student.lastName +
                    ")";
                const row = [
                    { value: count, html: count++ + "" },
                    { value: lab, html: lab },
                    { value: student.id, html: studentHTML },
                ];
                if (delivId !== "-None-") {
                    if (labSection === lab || labSection === "-All-" || (labSection === "-Unspecified-" && (lab === "" || lab === null))) {
                        st.addRow(row);
                    }
                    _listContainsStudents = true;
                }
            }
        }
        labSectionsOptions = labSectionsOptions.sort();
        UI_1.UI.setDropdownOptions("teamsListLabSelect", labSectionsOptions, labSection);
        st.generate();
    }
    static getTeams(remote) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminTeamsTab::getTeams( .. ) - start");
            try {
                const start = Date.now();
                const options = AdminView_1.AdminView.getOptions();
                const url = remote + "/portal/admin/teams";
                const response = yield fetch(url, options);
                if (response.status === 200) {
                    Log_1.default.trace("AdminTeamsTab::getTeams(..) - 200 received");
                    const json = yield response.json();
                    if (typeof json.success !== "undefined" && Array.isArray(json.success)) {
                        Log_1.default.trace("AdminTeamsTab::getTeams(..)  - worked; # teams: " + json.success.length + "; took: " + UI_1.UI.took(start));
                        return json.success;
                    }
                    else {
                        Log_1.default.trace("AdminTeamsTab::getTeams(..)  - ERROR: " + json.failure.message);
                        AdminView_1.AdminView.showError(json.failure);
                    }
                }
                else {
                    Log_1.default.trace("AdminTeamsTab::getTeams(..)  - !200 received: " + response.status);
                    const text = yield response.text();
                    AdminView_1.AdminView.showError(text);
                }
            }
            catch (err) {
                AdminView_1.AdminView.showError("Getting teams failed: " + err.message);
            }
            return [];
        });
    }
}
exports.AdminTeamsTab = AdminTeamsTab;
